import { Col } from 'antd'
import { getEmployeeFullName, getReviewerFullName } from '../../../shared/employeeUtil'
import { Meeting } from '../../../types'
import PerFlexRow from '../FlexRow'
import { IconCard } from '../IconCard'
import PerText from '../Text'
import RichTextBox from '../RichTextBox'

export interface MeetingStatusModalFeedbackProps {
  meeting?: Meeting
}

export const MeetingStatusModalFeedback = ({ meeting }: MeetingStatusModalFeedbackProps): JSX.Element | null => {
  if (!meeting) {
    return null
  }

  const employeeFeedback =
    meeting.employeePrepared && !!meeting.appraisal && !!meeting.appraisal.employeeGeneralFeedback
      ? meeting.appraisal.employeeGeneralFeedback
      : ''
  const reviewerFeedback =
    !!meeting.appraisal && !!meeting.appraisal.reviewerGeneralFeedback ? meeting.appraisal.reviewerGeneralFeedback : ''

  return (
    <>
      {!!employeeFeedback && (
        <Col span={8}>
          <IconCard icon="user_fill">
            <PerFlexRow justify="center">
              <PerText fontSize="m" fontWeight="bold" testId="feedback-employee-name">
                {getEmployeeFullName(meeting.employee)}
              </PerText>
            </PerFlexRow>
            <PerFlexRow mt="xl" justify="center">
              <RichTextBox text={employeeFeedback} readonly />
            </PerFlexRow>
          </IconCard>
        </Col>
      )}
      {!!reviewerFeedback && (
        <Col span={8}>
          <IconCard icon="user_fill">
            <PerFlexRow justify="center">
              <PerText fontSize="m" fontWeight="bold" testId="feedback-reviewer-name">
                {getReviewerFullName(meeting.reviewer)}
              </PerText>
            </PerFlexRow>
            <PerFlexRow mt="xl" justify="center">
              <RichTextBox text={reviewerFeedback} readonly />
            </PerFlexRow>
          </IconCard>
        </Col>
      )}
    </>
  )
}
